module.exports = __webpack_public_path__ + "static/gallery7-0164af843639c1fab4e45daad6848415.jpg";